import { httpClient } from '../httpClient';
import {
  IUserModel,
  PaginatedResponse,
  ModelQuery,
  PaginationQuery
} from '@packages/global';

/**
 * 用户模型 API 模块
 * 处理用户模型查询操作
 */
export class ModelApi {
  /**
   * 获取模型分页列表（POST，强类型）
   */
  async modelPageList(queryData: PaginationQuery<ModelQuery>): Promise<PaginatedResponse<IUserModel>> {
    return httpClient.post<PaginatedResponse<IUserModel>>('/user/models/page', queryData);
  }

  /**
   * 获取所有启用的模型（简化接口）
   */
  async getAllModels(params?: { type?: string }): Promise<IUserModel[]> {
    const queryParams = new URLSearchParams();
    if (params?.type) queryParams.append('type', params.type);

    const url = `/user/models/all${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    return httpClient.get<IUserModel[]>(url);
  }
}

// 导出单例实例
export const modelApi = new ModelApi();
